import React from "react";

export const ScrollContext  = React.createContext({scrollBar: null});
export const ScrollProvider = ScrollContext.Provider;
export const ScrollConsumer = ScrollContext.Consumer;
